/** Bengali application letter — Kalpurush (self-hosted in global.scss). */
export const FAMILY_CARD_FONT_FAMILY =
    "'Kalpurush', 'Noto Sans Bengali', 'SolaimanLipi', sans-serif";

/** Ensure Kalpurush is loaded before html2canvas PDF export. */
export async function ensureKalpurushFontLoaded() {
    if (typeof document === 'undefined') return;

    try {
        await Promise.all([
            document.fonts.load('400 12px Kalpurush'),
            document.fonts.load('700 14px Kalpurush'),
        ]);
        await document.fonts.ready;
    } catch {
        /* fallback to system / Noto */
    }
}
